"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputRegistry = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useInputRegistry = () => {
    return (0, react_1.useContext)(context_1.InputRegistryContext);
};
exports.useInputRegistry = useInputRegistry;
//# sourceMappingURL=hook.js.map